import { zLayoutNavigation } from 'core/styles/z-index';
import { darkTheme } from 'hfs-common-ui';
import styled from 'styled-components';

export const MobileBottomDiv = styled.div`
  padding-bottom: 80px;

  > div {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${zLayoutNavigation};
    background-color: ${({ theme }) => theme.colors.background};
    border-top: ${({ theme }) =>
    (theme === darkTheme ? `1px solid ${theme.colors.grey700}` : `1px solid ${theme.colors.grey200}`)};
  }
`;
